module.exports = __webpack_public_path__ + "static/media/pen.8d2303c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/pen.svg
// module id = 616
// module chunks = 0